import UsersTable from 'components/Settings/User';
import './index.scss';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Users = () => {
	const userPermissions = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
	const isUsersPermission = checkPermission(userPermissions, {
		permissionName: 'Users',
		permission: ['view'],
	});

	return <div> {isUsersPermission  && <UsersTable />}</div>;
};
